
import { moduleRegistry } from "constants";
import React from "react";


export function getComponent(moduleKey, ext) {
    const entry = moduleRegistry[moduleKey];
    if (!entry){
        console.log("Component not found for", moduleKey);
        return null;
    } 
  
    const { folder, name, context } = entry;
    const Component = React.lazy(() => import(`components/modules/${folder}/${name}${ext}`));
    return { Component, context };
}

export function getDetailComponent(moduleKey) {  
    const entry = getComponent(moduleKey, 'Details');
    const Context = entry.context ? entry.context() : null;
    const Component = entry.Component
    return { Component, Context };
}

export function getListComponent(moduleKey) {
    const { Component } = getComponent(moduleKey, 'List');
    return Component;
}

export function getViewComponent(moduleKey) {
    const { Component } = getComponent(moduleKey, '');
    return Component;
}